import { render, staticRenderFns } from "./PackageCategory.vue?vue&type=template&id=3c8842f5"
import script from "./PackageCategory.vue?vue&type=script&lang=js"
export * from "./PackageCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports